// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"7430d050","204":"7118371c","278":"1bec3c03","396":"e8a98d42","532":"75208a92","889":"24aef7fa"}[chunkId] + ".chunk.css";
};